import React, { useMemo, useEffect } from "react";
import { Label, FormFeedback, FormGroup } from "reactstrap";
import Select from "react-select";
import { useDispatch } from "react-redux";

import { getPerformanceRatingTypes } from "common/services/performance-rating.service";
import { normalize } from "common/lib/normalize";

const SelectPerformanceRatingType = ({
  validation,

  label,
}: {
  validation: any;

  label?: string;
}) => {
  const customSelectStyles = {
    control: (styles: any) => ({
      ...styles,
      borderColor:
        validation.touched?.performanceRatingType &&
        validation.errors?.performanceRatingType
          ? "red"
          : "#ced4da",
      "&:hover": {
        borderColor:
          validation.touched?.performanceRatingType &&
          validation.errors?.performanceRatingType
            ? "red"
            : "#ced4da",
      },
    }),
  };

  const dispatch: any = useDispatch();

  const [data, setData] = React.useState([]);
  const [, setError] = React.useState(null);
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const response = await getPerformanceRatingTypes({});
        setData(normalize(response.data));
        setError(null);
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [dispatch, setLoading]);

  const options = useMemo(() => {
    return data.map((el: any) => {
      return {
        value: el?.id,
        label: `${el?.name || ""}`,
      };
    });
  }, [data]);

  return (
    <FormGroup>
      <Label htmlFor={`performanceRatingType`} className="form-label">
        {label ? label : "Performance Rating"}
      </Label>
      <Select
        name={`performanceRatingType`}
        id={`performanceRatingType`}
        value={
          validation.values?.performanceRatingType?.value
            ? validation.values?.performanceRatingType
            : null
        }
        placeholder="Select rating"
        onChange={(value: any) => {
          validation.setFieldValue(`performanceRatingType`, value);
          validation.setFieldError(`performanceRatingType`, "");
        }}
        options={options}
        onBlur={() => validation.setFieldTouched(`performanceRatingType`, true)}
        className={
          validation.touched?.performanceRatingType &&
          validation.errors?.performanceRatingType
            ? "is-invalid"
            : ""
        }
        styles={customSelectStyles}
        isLoading={loading}
      />
      <FormFeedback>
        {validation.errors?.performanceRatingType?.value || ""}
      </FormFeedback>
    </FormGroup>
  );
};

export default SelectPerformanceRatingType;
